export const DOCUMENT_FILE_UPLOAD_EXTENSIONS = {
    pdf: 'application/pdf',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    txt: 'text/plain',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    csv: 'text/csv',
    dot: 'application/msword',
    dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    xml: 'application/xml',
    xps: 'application/oxps',
    ods: 'application/vnd.oasis.opendocument.spreadsheet',
    pot: 'application/vnd.ms-powerpoint',
    potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
    pps: 'application/vnd.ms-powerpoint',
    ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    json: 'application/json',
    pgp: 'application/pgp-encrypted',
    pgp_accept: '.pgp',
    zip: 'application/x-zip-compressed',
};

export const PGP_KEY_FILE_UPLOAD_EXTENSIONS = {
    gpg: '.gpg',
    key: '.key',
    pem: 'application/x-pem-file',
    secret: '.secret',
    txt: 'text/plain',
    pub: '.pub',
};

export const PROFILE_IMAGE_FILE_UPLOAD_EXTENSIONS = {
    jpeg: 'image/jpeg',
    jpg: 'image/jpg',
    png: 'image/png',
    gif: 'image/gif',
};

export const IMAGE_FILE_UPLOAD_EXTENSIONS = {
    svg: 'image/svg+xml',
    ...PROFILE_IMAGE_FILE_UPLOAD_EXTENSIONS,
};

export const VIDEO_FILE_UPLOAD_EXTENSIONS = {
    mp4: 'video/mp4',
    ogg: 'video/ogg',
    webm: 'video/webm',
    mov: 'video/quicktime',
};

export const AUDIO_FILE_UPLOAD_EXTENSIONS = {
    mp3: 'audio/mpeg',
};

export const RESOURCE_FORMATS = {
    video: 'VIDEO',
    ppt: 'PPT',
    pptx: 'PPTX',
    doc: 'DOC',
    docx: 'DOCX',
    png: 'PNG',
    pdf: 'PDF',
    other: 'OTHER',
};

export const YOUTUBE_VALIDATOR_REGEXP =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

export const VIMEO_VALIDATOR_REGEXP =
    /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)/;

export const VALID_VIDEO_FORMATS_LIST = ['mp4', 'ogg', 'webm'];

export const FORMATS = [
    ...Object.values(IMAGE_FILE_UPLOAD_EXTENSIONS),
    ...Object.values(DOCUMENT_FILE_UPLOAD_EXTENSIONS),
    ...Object.values(VIDEO_FILE_UPLOAD_EXTENSIONS),
    ...Object.values(AUDIO_FILE_UPLOAD_EXTENSIONS),
]
